import {
  REQUEST_USERCARD_BOOKING_DATA, RECEIVE_USERCARD_BOOKING_DATA, INVALIDATE_USERCARD_BOOKING_DATA
} from '../actions/UsercardBookingAction';


const usercardBooking = (state = {
  isFetching: false,
  didInvalidate: true,
  data: [],
  isActivityUser: true
}, action)=> {
  switch(action.type){
    case INVALIDATE_USERCARD_BOOKING_DATA:
      return { ...state,
        didInvalidate: true
      }
    case REQUEST_USERCARD_BOOKING_DATA:
      return { ...state,
              isFetching: true,
              didInvalidate: false
            }
    case RECEIVE_USERCARD_BOOKING_DATA:
      return { ...state,
        isFetching: false,
        didInvalidate: false,
        data: action.data,
        isActivityUser: action.isActivityUser,
        lastUpdated: action.receivedAt
      }
    default:
      return state;
  }
}

export default usercardBooking;



// WEBPACK FOOTER //
// ./src/reducers/usercardBooking.js